<template>
  <div class="camera-wrapper">
    <div class="camera-frame">
      <!-- <video ref="video" class="back-camera" autoplay playsinline muted></video> -->
      <!-- <video ref="video" class="back-camera" autoplay playsinline muted v-show="true"></video> -->
      <van-loading
        color="#C41627"
        class="loading-camera"
        v-show="isShowLoadingCamera"
      />
      <video
        ref="video"
        class="back-camera"
        autoplay
        playsinline
        muted
        poster="@/static/eSim/svg/bg-grey.svg"
      ></video>
      <div class="cccd-frame"></div>
      <div class="corner top-left"></div>
      <div class="corner top-right"></div>
      <div class="corner bottom-left"></div>
      <div class="corner bottom-right"></div>
    </div>
  </div>
</template>

<script>
import { contactCardProps } from "vant";

export default {
  name: "Camera",
  data() {
    return {
      stream: null,
      isFrontCamera: false,
      isMounted: false,
      isShowLoadingCamera: false,
    };
  },
  async mounted() {
    this.isMounted = true; 
    if (process.env.VUE_APP_ENV != "dev") {
      this.requestCameraPermission();
    }
  },
  beforeUnmount() {
    this.isMounted = false;
    this.stopCamera();
  },
  methods: {
    async waitForVideoRef(retry = 0) {
      return new Promise((resolve, reject) => {
        const check = () => {
          if (this.$refs.video) {
            resolve();
          } else if (retry < 50) {
            requestAnimationFrame(() => {
              this.waitForVideoRef(retry + 1)
                .then(resolve)
                .catch(reject);
            });
          } else {
            console.error("Video ref not found after 50 retries.", this.$refs);
            reject("Video ref not found.");
          }
        };
        check();
      });
    },

    async startCamera() {
      this.isShowLoadingCamera = true;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // Thử lần lượt các cấu hình constraints để ưu tiên camera sau
        const tryConstraints = [
          { video: { facingMode: { exact: "environment" } } },
          { video: { facingMode: "environment" } },
          { video: true },
        ];
        for (const constraints of tryConstraints) {
          try {
            const stream = await navigator.mediaDevices.getUserMedia(
              constraints
            );
            this.stream = stream;
            this.$refs.video.srcObject = stream;
            this.isShowLoadingCamera = false;
            return;
          } catch (err) {
            if (this.isMounted) {
              this.$notify({
                code: 1,
                message: this.$t("esim_access_required"),
              });
            }
            // Tiếp tục thử cấu hình khác
            continue;
          }
        }
      } else {
        if (this.isMounted) {
          this.$notify({
            code: 1,
            message: this.$t("esim_access_required"),
          });
        }
      }
    },

    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
        this.isMounted = false;
      }
    },

    async requestCameraPermission() {
      console.log("[CAMERA] Requesting camera permission...");
      try {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          await this.waitForVideoRef();
          await this.startCamera();
        } else {
          this.$notify({
            code: 1,
            message: this.$t("esim_access_required"),
          });
        }
      } catch (error) {
        console.error("[CAMERA] Error requesting camera permission:", error);
        this.handleCameraPermissionError(error);
      }
    },
    handleCameraPermissionError(error) {
      if (error.name === "NotAllowedError") {
        console.error("[CAMERA] Camera access denied.");
        alert("You need to grant camera access to use this feature.");
      } else if (error.name === "NotFoundError") {
        console.error("[CAMERA] No camera found on your device.");
        alert("No camera found on your device.");
      } else {
        console.error("[CAMERA] An error occurred while accessing the camera.");
        alert("An error occurred while accessing the camera.");
      }
    },
    capturePhoto() {
      const frame = this.$el.querySelector(".cccd-frame");
      const frameRect = frame.getBoundingClientRect();

      const cameraFrame = this.$el.querySelector(".camera-frame");
      const cameraRect = cameraFrame.getBoundingClientRect();

      const video = this.$refs.video;

      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;

      const frameWidth = cameraRect.width;
      const frameHeight = cameraRect.height;

      // Tính tỉ lệ hiển thị video so với vùng chứa
      const videoAspect = videoWidth / videoHeight;
      const frameAspect = frameWidth / frameHeight;

      let renderWidth, renderHeight;
      if (videoAspect > frameAspect) {
        // video bị crop chiều ngang => chiều cao bằng frameHeight
        renderHeight = frameHeight;
        renderWidth = frameHeight * videoAspect;
      } else {
        // video bị crop chiều dọc => chiều rộng bằng frameWidth
        renderWidth = frameWidth;
        renderHeight = frameWidth / videoAspect;
      }

      // Lệch giữa phần video thực sự hiển thị và camera frame
      const offsetX = (renderWidth - frameWidth) / 2;
      const offsetY = (renderHeight - frameHeight) / 2;

      // Toạ độ khung crop trên video gốc
      const cropX =
        (frameRect.left - cameraRect.left + offsetX) *
        (videoWidth / renderWidth);
      const cropY =
        (frameRect.top - cameraRect.top + offsetY) *
        (videoHeight / renderHeight);
      const cropWidth = frameRect.width * (videoWidth / renderWidth);
      const cropHeight = frameRect.height * (videoHeight / renderHeight);

      // Tạo canvas để crop
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(cropWidth);
      canvas.height = Math.round(cropHeight);

      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        video,
        cropX,
        cropY,
        cropWidth,
        cropHeight,
        0,
        0,
        canvas.width,
        canvas.height
      );

      const photo = canvas.toDataURL("image/jpeg", 1.0);
      this.$emit("photoCaptured", photo);
    },
  },
};
</script>

<style scoped>
.camera-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 100%; */
  padding: 0px;
}

.camera-frame {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
}

video {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
}

/* Các góc khung */
.corner {
  position: absolute;
  width: 30px;
  height: 30px;
  border: 4px solid white;
}

.top-left {
  top: 10px;
  left: 10px;
  border-right: none;
  border-bottom: none;
}

.top-right {
  top: 10px;
  right: 10px;
  border-left: none;
  border-bottom: none;
}

.bottom-left {
  bottom: 10px;
  left: 10px;
  border-right: none;
  border-top: none;
}

.bottom-right {
  bottom: 10px;
  right: 10px;
  border-left: none;
  border-top: none;
}

/* .cccd-frame {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    aspect-ratio: 85.6 / 64.5;
    height: auto;
    transform: translate(-50%, -50%);
    z-index: 2;
    pointer-events: none;
} */

.cccd-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  aspect-ratio: 1.45;
  transform: translate(-50%, -50%);
  z-index: 2;
  pointer-events: none;
}

.loading-camera {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
}

video::-webkit-media-controls {
  display: none !important;
}
</style>